module.exports = __webpack_public_path__ + "static/kafka-008bf3ae8ff73bbf7fa607b3b0f6df2f.png";